import React from 'react';

type Tone = 'neutral' | 'info' | 'primary' | 'warning';

interface CompanyStatCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  tone: Tone;
}

const TONES: Record<Tone, string> = {
  neutral: 'bg-gray-50 text-gray-600',
  info: 'bg-sky-50 text-sky-600',
  primary: 'bg-amber-50 text-amber-600',
  warning: 'bg-amber-50 text-amber-600',
};

/** Summary metric card shown in the companies-subscriptions stats grid. */
export function CompanyStatCard({ icon, label, value, tone }: CompanyStatCardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wider text-gray-500">{label}</span>
        <span className={`flex h-7 w-7 items-center justify-center rounded-md ${TONES[tone]}`}>{icon}</span>
      </div>
      <div className="mt-2 text-2xl font-semibold text-gray-900 tabular-nums">{value}</div>
    </div>
  );
}
